var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ai-skill-toggle",attrs:{"type":"button","title":"Codelos AI öffnen"},on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('img',{attrs:{"src":require("@/assets/newLogo.svg"),"alt":"Codelos AI"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }